import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

// Definimos estilos para el PDF
const styles = StyleSheet.create({
  sectionTitle: {
    backgroundColor: "#052956", // Fondo azul oscuro
    color: "#FFFFFF", // Letra en blanco
    fontWeight: "bold", // Letra en negrita
    fontSize: 12,
    textAlign: "center",
    padding: 8,
    marginBottom: 10,
  },
  table: {
    display: "table",
    width: "auto",
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColSmall: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    padding: 5,
  },
  tableColLarge: {
    width: "70%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    padding: 5,
  },
  tableColMedium: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    padding: 5,
  },
  tableCell: {
    fontSize: 10,
  },
  boldText: {
    fontWeight: "bold", // Para resaltar el texto
    fontFamily: "Times-Bold",
  },
});

const TablaCalificacion = ({
  evaluacion = { calificacion: {} },
  secciones = [],
}) => {
  const calificaciones = ["Muy Bajo", "Bajo", "Medio", "Alto", "Muy Alto"];

  return (
    <>
      {Array.isArray(secciones)
        ? secciones.map((seccion) => (
            <View key={seccion.key}>
              <Text style={styles.sectionTitle}>{seccion.title}</Text>
              <View style={styles.table}>
                {Array.isArray(seccion.questions)
                  ? seccion.questions.map((question) => {
                      const valor =
                        evaluacion?.calificacion &&
                        typeof evaluacion.calificacion === "object"
                          ? evaluacion.calificacion[question.section]?.valor
                          : undefined;

                      const calificacionTexto =
                        Number.isInteger(valor) && valor >= 1 && valor <= 5
                          ? calificaciones[valor - 1]
                          : "Sin evidencia";

                      return (
                        <View key={question.section} style={styles.tableRow}>
                          <View style={styles.tableColSmall}>
                            <Text style={[styles.tableCell, styles.boldText]}>
                              {question.section}
                            </Text>
                          </View>
                          <View style={styles.tableColLarge}>
                            <Text style={styles.tableCell}>
                              {question.description}
                            </Text>
                          </View>
                          <View style={styles.tableColMedium}>
                            <Text style={styles.tableCell}>
                              {calificacionTexto}
                            </Text>
                          </View>
                        </View>
                      );
                    })
                  : null}
              </View>
            </View>
          ))
        : null}
    </>
  );
};

export default TablaCalificacion;
